import pxToRem from "../../functions/pxToRem";
import linearGradient from "../../functions/linearGradient";

export default function switchButton({ colors, borders, boxShadows }) {
  const { white, gradients, grey, transparent } = colors;
  const { borderWidth } = borders;
  const { md } = boxShadows;

  const switchButton = {
    defaultProps: {
      disableRipple: false,
    },

    styleOverrides: {
      switchBase: {
        color: gradients.dark.main,

        "&:hover": {
          backgroundColor: transparent.main,
        },

        "&.Mui-checked": {
          color: gradients.dark.main,

          "&:hover": {
            backgroundColor: transparent.main,
          },

          "& .MuiSwitch-thumb": {
            borderColor: `${gradients.info.main} !important`,
          },

          "& + .MuiSwitch-track": {
            backgroundColor: `${gradients.info.main} !important`,
            borderColor: `${gradients.info.main} !important`,
            opacity: 1,
          },
        },

        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: "0.3 !important",
        },

        "&.Mui-focusVisible .MuiSwitch-thumb": {
          backgroundImage: linearGradient(gradients.info.main, gradients.info.state),
        },
      },

      thumb: {
        backgroundColor: white.main,
        boxShadow: md,
        border: `${borderWidth[1]} solid ${grey[400]}`,
      },

      track: {
        width: pxToRem(32),
        height: pxToRem(15),
        backgroundColor: grey[400],
        border: `${borderWidth[1]} solid ${grey[400]}`,
        opacity: 1,
      },

      checked: {},
    },
  };

  return switchButton;
}
